module.exports = __webpack_public_path__ + "img/sign_address.11ac6d4b.svg";